var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/cancel-line",
    clipPath: "url(#clip0_13011_29401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4167 2.5C8.8509 2.5 7.32029 2.9643 6.0184 3.8342C4.71652 4.70409 3.70182 5.94051 3.10262 7.38709C2.50343 8.83367 2.34665 10.4254 2.65212 11.9611C2.95759 13.4968 3.71158 14.9074 4.81874 16.0146C5.92591 17.1218 7.33652 17.8757 8.8722 18.1812C10.4079 18.4867 11.9997 18.3299 13.4462 17.7307C14.8928 17.1315 16.1292 16.1168 16.9991 14.8149C17.869 13.513 18.3333 11.9824 18.3333 10.4167C18.3333 8.31703 17.4993 6.3034 16.0146 4.81874C14.5299 3.33407 12.5163 2.5 10.4167 2.5ZM3.48959 10.4167C3.49006 8.75213 4.09289 7.144 5.18672 5.88932L14.944 15.6466C13.9405 16.5132 12.7094 17.0735 11.3969 17.2611C10.0844 17.4488 8.74563 17.2558 7.53955 16.7051C6.33347 16.1544 5.31076 15.2692 4.59287 14.1545C3.87497 13.0398 3.49206 11.7425 3.48959 10.4167ZM15.6466 14.944L5.88933 5.18672C7.21703 4.07736 8.91182 3.50502 10.6403 3.58229C12.3687 3.65957 14.0056 4.38086 15.2291 5.60428C16.4525 6.82769 17.1738 8.46464 17.251 10.1931C17.3283 11.9215 16.756 13.6163 15.6466 14.944Z",
    fill: "#848A9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13011_29401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelGrey);
export default __webpack_public_path__ + "static/media/cancel-grey.c829c2e519c86fd523ab98a1867426e1.svg";
export { ForwardRef as ReactComponent };